import { selectVariantFilterGridData } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
export type Row = {
    from_activity: string;
    to_activity: string;
    tasks: number;
    avg_duration: number;
    std_deviation: number;
    loop: boolean;
    compliant: boolean;
};

export type GridRow = Row & { id: number }

export type SetVariantSlicerSelectedDataProps = ApiMethodBase & {
    selection: Row[];
};

export const setVariantFilterSelectedData = ({
    selection,
}: SetVariantSlicerSelectedDataProps) => {
    selectVariantFilterGridData(selection);
};
